import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,
  targetId: null,

  // model
  configModel: {},
  layoutModel: {},

  // values
  values: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, screenConfigMstUuid) {
    commit('setTargetId', screenConfigMstUuid)
		// cover
		this.dispatch('core/showModalCover')
		// show
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 画面構成マスタレイアウトの詳細を読出し
   */
  loadModel ({commit}, {screenConfigDetailParams, screenConfigLayoutParams}) {
    return new Promise((resolve, reject) => {
      //TODO v1ScreenConfigMstDetailGetは不要かも
      ApiManager.request(
        [
          // 'screenConfigMst',
          'screenConfigMst'
        ],
        [
          // 'v1ScreenConfigMstDetailGet',
          'v1ScreenConfigMstLayoutGet'
        ],
        [
          // screenConfigDetailParams,
          screenConfigLayoutParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            // commit('setConfigModel', res[0].data.screenConfigMst)
            commit('setLayoutModel', res[0].data.screenConfigMst)
            // console.log('configModel', state.configModel)
            console.log('layoutModel', state.layoutModel)

            // valuesに反映
            this.dispatch('screenConfigLayout/initLayer')

            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 
   */
  initLayer ({commit}) {
    let layers = []
    if (state.layoutModel.screenLayout) {
      Object.keys(state.layoutModel.screenLayout)
        .forEach(key => {
          let data = state.layoutModel.screenLayout[key]
            .forEach(item => {
              item.type = key
              layers.push(item)
            })
        })
    }
    commit('setValues', layers)
  },

  /**
   * レイヤー情報をvalueに追加／更新
   */
  setLayer ({commit}, data) {
    if (!data) return
    try {
      let index
      let multiple = this.state.screenConfigLayoutConst.moduleType.filter(item => item.value === data.type)[0].multiple
      if (multiple) {
        index = state.values.findIndex(item => item.type === data.type && item.uuid === data.uuid)
      } else {
        index = state.values.findIndex(item => item.type === data.type)
      }

      // レイヤー追加の場合
      if (index === -1) {
        console.log('ここでuuid発行', data)
        // uuidをクライアントで生成
        if (data.uuid === null) {
          // data.uuid = data.type + '_' + (new Date()).getTime()
          data.uuid = Utility.generateUuid()
        }
        // zIndexが一番大きくなるように変更して登録
        data.zIndex = 9999999
        commit('addValue', data)
        commit('formatZIndex')

      // レイヤー更新の場合
      } else {
        commit('updateValue', {
          index: index,
          data: data
        })
      }

    /* eslint-disable no-new */
    } catch (e) {
      return
    }
  },
  /**
   * レイヤー情報をvalueから削除
   */
  removeLayer ({commit}, data) {
    if (!data || !data.type) return
    try {
      let index
      let multiple = this.state.screenConfigLayoutConst.moduleType.filter(item => item.value === data.type)[0].multiple
      if (multiple) {
        index = state.values.findIndex(item => item.type === data.type && item.uuid === data.uuid)
      } else {
        index = state.values.findIndex(item => item.type === data.type)
      }
      if (index === -1) return
      commit('removeValue', index)
      commit('formatZIndex')

    /* eslint-disable no-new */
    } catch (e) {
      return
    }
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},
  setTargetId (state, id) {
    state.targetId = id
  },

  // form
  setValues (state, data) {
    Vue.set(state, 'values', data)
  },
  addValue (state, data) {
    state.values.push(data)
  },
  updateValue (state, {index, data}) {
    Vue.set(state.values, index, data)
  },
  removeValue (state, index) {
    state.values.splice(index, 1)
  },

  // zIndexを整理する
  formatZIndex (state) {
    let len = state.values.length
    let values = state.values.sort(Utility.sortByKey('zIndex', true))
    values = values.map((item, index) => {
      item.zIndex = index
      return item
    })
  },

  // model
  setConfigModel (state, data) {
    Vue.set(state, 'configModel', data)
  },
  setLayoutModel (state, data) {
    if (data.screenLayout !== undefined) {
      Vue.set(data, 'screenLayout', JSON.parse(data.screenLayout))
    }
    Vue.set(state, 'layoutModel', data)
  },

  // reset
  reset (state) {
    state.targetId = null
    Vue.set(state, 'configModel', {})
    Vue.set(state, 'layoutModel', {})
    Vue.set(state, 'values', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
